import React, { useContext } from "react";
import styles from "./Table.module.scss";
import PathContext from "../../context/path";
const Table = () => {
  const path = useContext(PathContext);
  return (
    <>
      <div className={styles.wrap} data-opacity-trigger>
        <div className={styles.row}>
          <div className={styles.col}>Блок</div>
          <div className={styles.col}>Содержание</div>
          <div className={styles.col}>Особенности</div>
          <div className={styles.col}>Интерактив</div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}><span>Блок</span>Достижения</div>
          <div className={styles.col}><span>Содержание</span>Финансовые результаты, крупные проекты и партнёрства, масштабирование бизнеса и т.д.</div>
          <div className={styles.col}><span>Особенности</span>В каждом достижении подчеркните конкретные роли сотрудников</div>
          <div className={styles.col}><span>Интерактив</span>Голосование за самое значимое достижение</div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}><span>Блок</span>Истории успеха</div>
          <div className={styles.col}><span>Содержание</span>Личные истории сотрудников об их вкладе в успехи компании, благодарности от руководства и коллег</div>
          <div className={styles.col}><span>Особенности</span>Сфокусируйтесь на опыте и достижениях работников, подчеркните их ценность</div>
          <div className={styles.col}><span>Интерактив</span>Раздел с возможностью оставить благодарность любому коллеге</div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}><span>Блок</span>Признание персональных вкладов</div>
          <div className={styles.col}><span>Содержание</span>Бонусы для сотрудников, которые принесли наиболее значимую пользу компании</div>
          <div className={styles.col}><span>Особенности</span>Выразите вклад сотрудника в цифрах или прибыли для компании — это усилит значимость достижения</div>
          <div className={styles.col}><span>Интерактив</span>Голосование за самого значимого сотрудника</div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}><span>Блок</span>Планы и цели</div>
          <div className={styles.col}><span>Содержание</span>Стратегические цели, ключевые инициативы и проекты</div>
          <div className={styles.col}><span>Особенности</span>Расскажите, как каждый сотрудник может внести свой вклад и какое значение это будет иметь</div>
          <div className={styles.col}><span>Интерактив</span>Раздел для обсуждения планов и предложения идей</div>
        </div>
        <div className={styles.row}>
          <div className={styles.col}><span>Блок</span>Опросы и обратная связь</div>
          <div className={styles.col}><span>Содержание</span>Сбор мнений и предложений сотрудников по всем аспектам работы компании</div>
          <div className={styles.col}><span>Особенности</span>Сделайте опросы анонимными, чтобы каждый мог честно высказаться</div>
          <div className={styles.col}><span>Интерактив</span>Анонимная публикация результатов с предложениями по решению проблем</div>
        </div>
      </div>
    </>
  );

}

export default Table;
